<div class="w-100 notes clearfix">
  <h5>Notes</h5>
  <p [innerHTML]="this.notesData.prompt"></p>
  <div class="textbox-section">
    <mat-form-field class="w-100">
      @if (moduleNotes && notesData.required) {
        <div class="notes-notification" [ngClass]="{ valid: note }">
          @if (note && moduleNoteSaved) {
            <mat-icon class="me-1">thumb_up</mat-icon>Required Notes Entered for
            This Module
          } @else {
            <mat-icon class="me-1">error</mat-icon>Notes Required for This
            Module
          }
        </div>
      }
      <mat-label>Enter Notes Here</mat-label>
      <textarea
        #noteInput
        matInput
        [placeholder]="'Enter Notes Here'"
        [formControl]="noteInputControl"
        [(ngModel)]="note"
        (keyup)="noteTyped($event)"
      ></textarea>
      @if (note) {
        <mat-hint> Characters entered: {{ note.length }} </mat-hint>
      }
      @if (
        note &&
        (noteInputControl.hasError('minlength') ||
          noteInputControl.hasError('required'))
      ) {
        <mat-error align="start">
          Note must be 10 characters or more. {{ note.length }} / 10
        </mat-error>
      }
      <br />
      @if (noteInputControl.hasError('pattern')) {
        <mat-error align="start">
          Note has too many consecutive spaces.
        </mat-error>
      }
    </mat-form-field>
    @if (
      canSpeechToText &&
      (!rights.includes('ReadOnly') || !rights.includes('ReadOnlyAccess'))
    ) {
      <app-speech-to-text
        [speechReviewed]="voiceReviewed"
        [typedText]="typedText"
        (text)="applySpeechToTextNote($event)"
        (noteSpeechError)="applySpeechToTextError($event)"
      />
    }
  </div>
  <div class="note-actions-container">
    @if (usedVoice) {
      <div class="voice-review-container">
        <div class="checkbox-content-container">
          <mat-checkbox
            [checked]="voiceReviewed"
            (change)="speechReviewEvent($event)"
            >I have reviewed and confirmed the accuracy of this note, including
            any speech-to-text dictation.</mat-checkbox
          >
        </div>
      </div>
    }
    @if (noteShouldProcessByAi) {
      <button
        type="button"
        matButton="elevated"
        color="primary"
        class="submit-note-btn"
        [disabled]="
          noteInputControl.errors ||
          !note ||
          !fieldTouched ||
          (usedVoice && !voiceReviewed)
        "
        (click)="validateAndSaveNote()"
      >
        Save & Review
      </button>
    } @else {
      <button
        type="button"
        matButton="elevated"
        color="primary"
        class="submit-note-btn"
        [disabled]="noteInputControl.errors || !note || !fieldTouched"
        (click)="saveNote()"
      >
        Save Note
      </button>
    }
  </div>

  <div class="note-score-container">
    @if (noteSaved && noteProcessedByAi) {
      <div [ngClass]="noteScore">
        <div>
          @if (noteScore === 'positive') {
            <mat-icon class="close-icon" (click)="closeValidation()">
              close
            </mat-icon>
            Your note was reviewed and saved.
          } @else if (noteScore === 'negative' || noteScore === 'error') {
            <mat-icon class="close-icon" (click)="closeValidation()">
              close
            </mat-icon>
            <div class="score-message-container">
              <markdown [data]="scoreMessage" />
            </div>
          }
        </div>
      </div>
    }
    @if (containsPii) {
      <div class="negative">
        <div>
          <mat-icon class="close-icon" (click)="closePii()">close</mat-icon>
          The submitted note appears to have sensitive information in it like an
          SSN or Account Number(s). Please check for this, remove any of these
          details, and try again.
        </div>
      </div>
    }
    @if (noteSpeechError) {
      <div class="negative">
        <div>
          <mat-icon class="close-icon">close</mat-icon>
          {{ noteSpeechError }}
        </div>
      </div>
    }
    @if (noteSaved && !noteProcessedByAi && !containsPii) {
      <div class="note-save-success">
        <div> <mat-icon>thumb_up</mat-icon> Your note was saved. </div>
      </div>
    }
    @if (finalResponseMessage && displayFinalSubmissionNote) {
      <div class="note-save-warn pt-2">
        <div> <mat-icon>warning</mat-icon> {{ finalResponseMessage }} </div>
      </div>
    }
  </div>
</div>
<ngx-loading [show]="loading" />
